import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageRoot = lazy(() => import('@app/components/PageRoot'))
const AiHubRouterWithProviders = lazy(() => import('./AiHubRouterWithProviders.tsx'))

class AiHubRouterWebComponent extends ReactWebComponent {
  override render() {
    return (
      <PageRoot>
        <AiHubRouterWithProviders />
      </PageRoot>
    )
  }
}

customElements.define('ai-hub-router', AiHubRouterWebComponent)
